import { ETL_SOURCES_LIST_TAG, ETL_SOURCES_TAG } from '@/model/etlSource/tags';
import { sourceStateApi } from '@/model/sourceState/api.generated';

export const SOURCE_STATES_TAG = 'source-states' as const;

export function registerSourceStateTags(): void {
  sourceStateApi.enhanceEndpoints({
    endpoints: {
      getApiProjectsByProjectIdSourceStates: {
        providesTags: (_result, _error, arg) => [
          { type: SOURCE_STATES_TAG, id: arg.projectId },
          ETL_SOURCES_LIST_TAG,
        ],
      },
      getApiProjectsByProjectIdSourceStatesAndSourceId: {
        providesTags: (_result, _error, arg) => [
          { type: SOURCE_STATES_TAG, id: arg.projectId },
          { type: ETL_SOURCES_TAG, id: arg.sourceId },
        ],
      },
    },
  });
}
